import SummarizeIcon from '@mui/icons-material/Summarize';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import { Box, Grid } from '@mui/material'
import CreateInvestmentConcept from '../../pitch-documents/components/CreateInvestmentConcept'
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import RecentDocuments from './dashboard/RecentDocuments';
import { getAllUsers, getAnalyzedDocuments } from '../../services/services';
import { useState } from 'react';
import { useEffect } from 'react';
import secureLocalStorage from 'react-secure-storage';

const SubAdminDashboard = () => {

  //#region variables
  const [recentDocuments,setRecentDocuments] = useState();
  const [activeUsers,setActiveUsers] = useState();
  const userHistoryDetails = [
    { title: 'Documents', value: recentDocuments?.length, icon: <SummarizeIcon style={{ width: '40px',height: '40px' }} /> },
    { title: 'Suggested Readings', value: '-', icon: <EmojiObjectsIcon  style={{ width: '40px',height: '40px' }} /> },
    { title: 'Risk Flags', value: '-', icon: <EmojiFlagsIcon  style={{ width: '40px',height: '40px' }} /> },
  ]

  //#region api get calls
  const getDocuments = async () => {
    const response = await getAnalyzedDocuments();
    if (response.status === 200) {
      const sortedDocs = response.data
      setRecentDocuments(sortedDocs);
    } else {
      console.error("Failed to fetch documents", response);
    }
  }

  const getActiveUsers = async () => {
    const response = await getAllUsers();
    if(response.status === 200) {
      const sortedUsers = response.data?.filter((user) => user.isActive === true)
      setActiveUsers(sortedUsers);
    } else {
      console.error("Failed to fetch active users", response);
    }
  }

  //#region useeffect
  useEffect(() => {
    getDocuments();
    getActiveUsers();
  },[]);

  const styles={
    iconStyle: {
      height: '50px',
      width: '50px',
    }
  }

  return (
    <Box className='padding-40'>
      <Grid container spacing={2} >
        <Grid item size={12}>
          <div className='dashboard-header'>
            <div className='welcome-title'>Welcome Back, <span>{secureLocalStorage.getItem("fullName")}</span></div>
            <div className='welcome-subtitle'>From Documents to Decisions in Seconds</div>
          </div>
        </Grid>
        <Grid item size={12}>
          <div className='dashboard-banner space-between'>
            <div>
              <div className="dashboard-title">New Spring Analytics Dashboard</div>
              <div className="dashboard-main-stat">
                AI Insights
              </div>
              <div className="dashboard-subtext">Across {recentDocuments?.length} documents</div>
            </div>
            <div className="dashboard-analyst-box">
              <div className="dashboard-analyst-label">Active Analysts</div>
              <div className="dashboard-analyst-count">{activeUsers?.length || "-"}</div>
            </div>
          </div>
        </Grid>
        <Grid item size={12}>
          <Grid container spacing={2}>
            <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
              <div className='white-card height-400 child-margin-10 align-item-center'>
                <div className='grid-header'>Upload for Analysis</div>
                <CreateInvestmentConcept />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 8 }}>
              <Grid container spacing={2}>
                {/* <Grid item size={12}>
                  <Grid container spacing={2}>
                    {
                      userHistoryDetails?.map((item, index) => (
                        <Grid item size={{ xs: 12,md: 4 }} key={index}>
                          <div className="white-background space-between align-items-center">
                            <div className='child-margin-5'>
                              <div className='dashboard-card-title'>{item.title}</div>
                              <b className='dashboard-card-value'>{item.value}</b>
                            </div>
                            <div>
                              {item.icon}
                            </div>
                          </div>
                        </Grid>
                      ))
                    }
                  </Grid>
                </Grid> */}
                <Grid item size={12}>
                  <RecentDocuments 
                    recentDocuments={recentDocuments
                      ?.sort((a, b) => new Date(b.updatedOn) - new Date(a.updatedOn))
                      ?.slice(0, 3)} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default SubAdminDashboard